module.exports = __webpack_public_path__ + "img/bg_with_light.8c03bbc1.png";